/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ETargetDossier {
    Centres = 'Centres',
    Services = 'Services'
}


export function ETargetDossierFromJSON(json: any): ETargetDossier {
    return ETargetDossierFromJSONTyped(json, false);
}

export function ETargetDossierFromJSONTyped(json: any, ignoreDiscriminator: boolean): ETargetDossier {
    return json as ETargetDossier;
}

export function ETargetDossierToJSON(value?: ETargetDossier | null): any {
    return value as any;
}

